import axios from "axios";
import { getApiBase } from "../apiBase";

export async function postForgotPassword({ email, appOrigin }) {
  const { data } = await axios.post(`${getApiBase()}/auth/forgot-password`, {
    email,
    appOrigin,
  });
  return data;
}

export async function postResetPassword({ token, newPassword }) {
  const { data } = await axios.post(`${getApiBase()}/auth/reset-password`, {
    token,
    newPassword,
  });
  return data;
}
